import React from 'react';

interface NeaLogoProps {
  /** Alto en píxeles. El ancho se ajusta manteniendo la proporción. */
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Marca de NEA Ambiental. Va como SVG en línea y no como archivo: el informe se
 * imprime desde el navegador y una imagen externa puede no llegar a cargar
 * antes de que se genere el PDF.
 */
export const NeaLogo: React.FC<NeaLogoProps> = ({ height = 48, className = '', style }) => (
  <svg
    viewBox="0 0 220 64"
    height={height}
    width={(height * 220) / 64}
    role="img"
    aria-label="NEA Ambiental"
    className={className}
    style={style}
  >
    <path d="M6 58V6h11l20 30V6h11v52H37L17 28v30H6z" fill="#195745" />
    <path
      d="M62 58V6h34v10H73v11h21v10H73v11h23v10H62zM104 58 122 6h12l18 52h-12l-3.4-10.5h-17.2L116 58h-12zm19.6-20h11l-5.5-17-5.5 17z"
      fill="#195745"
    />
    <path
      d="M165 44c9-2 15-8 18-16 3 9 9 14 18 16-9 2-15 7-18 16-3-9-9-14-18-16z"
      fill="#2C8268"
    />
    <path d="M6 62h206" stroke="#2C8268" strokeWidth="3" fill="none" />
  </svg>
);

export default NeaLogo;
